import { CommonResponse } from '@redux/model';
import { IState } from '@redux/reducer';
import { TypeLangs } from '@redux/reducer/localeReducer';
import { typeCurrentUserOrgs } from '@redux/reducer/selectCurrentOrgReducer';
import { useSelector } from '@redux/store';
import { IconCheckMark, IconLookup, IconSecurity, IconWarningMark } from '@shares/DMPIcon';
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Empty,
  Form,
  Icon,
  Input,
  Modal,
  Row,
  Tooltip,
  Typography,
} from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { FormComponentProps } from 'antd/lib/form';
import { debounce, filter, isEmpty, sortBy } from 'lodash';
import { changeAntdTheme, generateThemeColor } from 'mini-dynamic-antd-theme';
import moment from 'moment';
import { TypeOrganization, TypeTermOfOrg, UISetting } from 'o2o_layout/lib/common/model';
import queryString from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Helmet from 'react-helmet';
import { typeGetMe } from '../../common/actions/CommonAction';
import CommonTypeProps from '../../common/CommonTypeProps';
import { BIGDATA_CONSTANT } from '../../common/constant';
import { UserDAL } from '../../dal/UserDAL';
import { LandingPage } from '../../layout/landing/LandingPage';
import PopoverInviteUser from '../users/company/PopoverInviteUser';
import { ConsoleUsersDAL } from '../users/ConsoleUserDAL';
import './company.scss';
import { ListCompanySelectComponent } from './ListCompanySelectComponent';
import useGetCheckUserAcceptedTermOfOrg from '../system-setting/privacy-sytem/hooks/useGetCheckUserAcceptedTermOfOrg';
import useGetTermPangoConfig from '../system-setting/privacy-sytem/hooks/useGetTermPangoConfig';
import DOMPurify from 'dompurify';

export const sanitizeHtml = (dirtyHtml: string | undefined | null): string => {
  if (!dirtyHtml) return '';
  return DOMPurify.sanitize(dirtyHtml, {
    // Chỉ cho phép các thẻ định dạng nội dung văn bản thông thường
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'p', 'b', 'i', 'strong', 'em', 'u', 's',
      'ul', 'ol', 'li', 'span', 'br', 'hr',
      'blockquote', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'a',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
    // Chặn triệt để các thẻ có thể dùng để Deface giao diện hoặc tạo Form lừa đảo
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'iframe', 'frame', 'script', 'object', 'embed'],
  });
};
interface IpropsFilter extends FormComponentProps {
  onSearch: any;
}

const SearchCompany = Form.create<IpropsFilter>()((props: IpropsFilter) => {
  const search = (e: any) => {
    props.onSearch(e);
  };
  const searchDebounce = React.useCallback(debounce(search, 500), []);
  return (
    <>
      <Form>
        <Form.Item style={{ marginBottom: 0 }}>
          {props.form.getFieldDecorator('search')(
            <Input
              suffix={<IconLookup style={{ width: 25, height: 25 }} />}
              className='input-search-company-name'
              placeholder='Enter Organization name...'
              allowClear
              onChange={(e: any) => {
                searchDebounce(e.target.value);
              }}
            ></Input>
          )}
        </Form.Item>
      </Form>
    </>
  );
});

type TSelectCompaniesV2Component = CommonTypeProps & {
  location: Location;
  getCurrentUserOrgs: any;
  currentUserOrgs: typeCurrentUserOrgs;
  selectUserOrg: any;
  commonResponse: CommonResponse;
  getMe: typeGetMe;
  getUISettingCtx: any;
  uiSetting: UISetting;
};

const SelectCompanyV2Component = (props: TSelectCompaniesV2Component) => {
  const [url, setUrl] = useState<string>('');
  const [token, setToken] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [query, setQuery] = useState<string>('');
  const [selectedOrgName, setSelectedOrgName] = useState<string>('');
  console.log("🚀 ~ SelectCompanyV2Component ~ selectedOrgName:", selectedOrgName)
  const [term, setTerm] = useState<undefined | TypeTermOfOrg>();
  const [totalInviteUser, setTotalInviteUser] = useState<number>(0);

  const [checkedTerm, setCheckTerm] = useState<boolean>(false);
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [visibleTermAccept, setVisibleTermAccept] = useState<boolean>(false);
  const [visibleTermPangoAccept, setVisibleTermPangoAccept] = useState<boolean>(false);
  const [selectedOrgCurrentAccpt, setSelectedOrgCurrentAccpt] = useState<boolean>(false);
  const [isFirstLogin, setIsFirstLogin] = useState<boolean>(false);

  const isLoading = useSelector((state: IState) => state.ui.isLoading);

  let checkboxTerm: any;
  const listOrgOfUser = props.currentUserOrgs?.orgs?.results;
  const capchaRef = useRef<any>(null);

  useEffect(() => {
    const isFirstLoggedIn = sessionStorage.getItem('isFirstLoggedIn') === 'true';
    if (isFirstLoggedIn && listOrgOfUser && listOrgOfUser?.length === 1 && totalInviteUser === 0)
      setIsFirstLogin(isFirstLoggedIn);
    else setIsFirstLogin(false);
  }, [listOrgOfUser, sessionStorage.getItem('isFirstLoggedIn')]);

  useEffect(() => {
    let targetUrl = '/my-account-info';
    const qString = props.location.search;
    const parseQuery = queryString.parse(qString);
    if (parseQuery.target) {
      if (parseQuery.target == 'my-account-info') {
      } else if (parseQuery.target == 'ga') {
        targetUrl += '/ga';
      }
    }
    if (listOrgOfUser?.length === 1 && token && isFirstLogin) {
      handleSelectOrg(listOrgOfUser[0], targetUrl, () => {
        props.setGlobalLoading(false);
        sessionStorage.setItem('isFirstLoggedIn', 'false');
        setIsFirstLogin(false);
      });
      return;
    }
  }, [props.currentUserOrgs.orgs, token, isFirstLogin]);

  useEffect(() => {
    handleUpdateLang();
    getCurrentUserOrgs();
    changeAntdTheme(generateThemeColor(BIGDATA_CONSTANT.primaryColor));

    let query: any = queryString.parse(props.location.search);
    if (query && !isEmpty(query)) {
      let url: string = query.url;
      if (url) setUrl(url);
    }

    const intervalID = setInterval(() => handleRecapchaloop(), 60 * 1000);
    handleCountTotalInviteByStatus();

    return () => {
      clearInterval(intervalID);
    };
  }, []);

  const { handleSetOrgId, response: termPango } = useGetCheckUserAcceptedTermOfOrg();
  const { response } = useGetTermPangoConfig();
  const onCheckAcceptTermPango = async () => {
    const res = await handleSetOrgId('platform');
    if (res?.success && !res.accepted) {
      setVisibleTermPangoAccept(!res.accepted);
    }
  };

  useEffect(() => {
    console.log(response);
    if (response?.success && response.result?.active) onCheckAcceptTermPango();
  }, [response]);

  const handleRecapchaloop = () => {
    if (!capchaRef?.current?.executeRecaptcha) return;

    const { executeRecaptcha } = capchaRef?.current;

    if (!executeRecaptcha) {
      console.log('Recaptcha has not been loaded');
      return;
    }

    executeRecaptcha('register').then((token: string) => {
      setToken(token);
    });
  };

  const handleUpdateLang = () => {
    let qString = props.location.search;
    const parseQuery = queryString.parse(qString);

    if (parseQuery.lang) {
      // debugger
      const lang: TypeLangs = parseQuery.lang == 'vi' || parseQuery.lang == 'en' ? parseQuery.lang : 'vi';
      props.updateLocale(lang);
    }
  };

  const getCurrentUserOrgs = () => {
    props.getCurrentUserOrgs().then((res: any) => {
      // handle empty orgs if needed
    });
  };

  // const handleSuccessChangeLang = (key: string) => {
  //     let qString = props.location.search;
  //     const parseQuery = queryString.parse(qString)
  //     parseQuery.lang = key;
  //     qString = queryString.stringify(parseQuery);
  //     props.history.push({ pathname: props.location.pathname, search: qString })
  // }

  const handleGetTerm = (orgId: string) => {
    let term: TypeTermOfOrg | undefined = props.currentUserOrgs?.orgs?.terms?.[orgId || ''] || undefined;
    return term;
  };

  const handleGetNameBeforAt = (email?: string) => {
    if (!email) return;
    const atIndex = email.indexOf('@');
    if (atIndex === -1) return email; // không có dấu @ thì trả về nguyên chuỗi
    return email.slice(0, atIndex + 1); // lấy từ đầu tới dấu @ (bao gồm dấu @)
  };

  const handleContinuteToPangoCDP = async (orgId: string, target: string, callback: any) => {
    if (!token) {
      setLoadingModal(false);
      setErrorMsg('Capcha is required.');
      setShowMessage(true);
      // this.setState({ loading: false, showMessage: true, message: "Capcha is required." })
      window.location.reload();
      return;
    }

    let ipData;
    let userAgent = window.navigator.userAgent;

    try {
      const ip = await props.commonActionFromDALV2(UserDAL.getIP);
      ipData = await ip;
    } catch (error) { }

    const header = {
      'P-IP-ACCESS': ipData ? ipData.data || '' : '',
      'P-USR-AGENT': userAgent,
    };

    /*@ts-ignore */
    const orgUIs = props.currentUserOrgs.orgs.orgUIs;
    const themeColor = orgUIs && orgUIs[orgId] && orgUIs[orgId].themeColor !== null ? orgUIs[orgId].themeColor : '#ccc';

    props.selectUserOrg(orgId, header, token).then(() => {
      changeAntdTheme(generateThemeColor(BIGDATA_CONSTANT.primaryColorDelay));
      Promise.all([props.getMe(), props.getUISettingCtx()])
        .then((user: any) => {
          props.setGlobalLoading(false);
          // this.setState({ pendingGUI: false })

          if (themeColor) {
            changeAntdTheme(generateThemeColor(themeColor ? themeColor : BIGDATA_CONSTANT.primaryColor));
          } else {
            changeAntdTheme(generateThemeColor(BIGDATA_CONSTANT.primaryColor));
          }
          if (url) {
            window.location.href = url;
          } else {
            props.history.push({
              pathname: target,
              search: queryString.stringify({
                lang: queryString.parse(props.location.search).lang,
              }),
            });
          }

          if (callback && typeof callback == 'function') {
            callback();
          }
        })
        .catch((error: any) => {
          props.setGlobalLoading(false);
          changeAntdTheme(generateThemeColor(BIGDATA_CONSTANT.primaryColor));
        });
    });
  };

  const renderModalTerm = () => {
    return (
      <Modal
        visible={visibleTermAccept}
        title='Terms of use'
        closable={false}
        onCancel={() => setVisibleTermAccept(false)}
        footer={
          <Row gutter={[5, 5]}>
            <Col xs={24} style={{ textAlign: 'start', marginBottom: 10 }}>
              <div>
                <Checkbox
                  checked={checkedTerm}
                  onChange={(e: CheckboxChangeEvent) => {
                    setCheckTerm(e.target.checked);
                  }}
                  ref={(ref: any) => {
                    if (ref) {
                      checkboxTerm = ref;
                    }
                  }}
                  defaultChecked={selectedOrgCurrentAccpt}
                >
                  I Agree
                </Checkbox>
              </div>
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <Button
                key='back'
                onClick={() => {
                  setVisibleTermAccept(false);
                }}
              >
                Close
              </Button>
              <Button
                key='submit'
                type='primary'
                disabled={!checkedTerm}
                loading={loadingModal}
                onClick={() => {
                  if (checkboxTerm) {
                    let checked = checkboxTerm.rcCheckbox.input.checked;

                    if (checked) {
                      setLoadingModal(true);
                      props
                        .commonActionFromDAL(ConsoleUsersDAL, 'acceptedTermOfOrg', term ? term.orgId : '')
                        .then(() => {
                          setLoadingModal(false);
                          let targetUrl = '/my-account-info';

                          const qString = props.location.search;
                          const parseQuery = queryString.parse(qString);
                          if (parseQuery.target) {
                            if (parseQuery.target == 'my-account-info') {
                            } else if (parseQuery.target == 'ga') {
                              targetUrl += '/ga';
                            }
                          }

                          handleContinuteToPangoCDP(term ? term.orgId : '', targetUrl, undefined);
                        });
                    } else {
                    }
                  }
                }}
              >
                Continue
              </Button>
            </Col>
          </Row>
        }
      >
        <Row type='flex' gutter={[10, 10]}>
          <Col>
            <div
              style={{ height: '50vh', overflowY: 'scroll' }}
              dangerouslySetInnerHTML={{
                __html: term
                  ? sanitizeHtml(term.term)
                  : `<div><h1>Legal Notice</h1><div>This information asset and information system is the property of ${escape(selectedOrgName)}.</div><div>The use of this system is governed by IT Policies under OGR.</div><div>It must be used responsibly and for authorized purposes only.</div><p>Unauthorized or improper use of this system may result in disciplinary action and/or civil charges/criminal penalties and/or prosecution of law. By continuing to use this system you indicated your awareness and consent to these terms and conditions of use.</div></div>`,
              }}
            ></div>
          </Col>
        </Row>
      </Modal>
    );
  };

  const renderModalTermPango = () => {
    return (
      <Modal
        visible={visibleTermPangoAccept}
        afterClose={() => {
          setCheckTerm(false);
        }}
        destroyOnClose
        closable={false}
        maskClosable={false}
        bodyStyle={{ padding: '0px 12px 0px 24px' }}
        title='Terms of use'
        onCancel={() => setVisibleTermPangoAccept(false)}
        footer={
          <Row type='flex' gutter={[5, 5]}>
            <Col xs={24} style={{ textAlign: 'start', marginBottom: 10 }}>
              <Checkbox
                className='mr8'
                checked={checkedTerm}
                onChange={(e: CheckboxChangeEvent) => {
                  setCheckTerm(e.target.checked);
                }}
                ref={(ref: any) => {
                  if (ref) {
                    checkboxTerm = ref;
                  }
                }}
                defaultChecked={selectedOrgCurrentAccpt}
              />
              I have read and agree to the{' '}
              <Button
                href='https://pangocdp.com/en/data-privacys-pangocdp/'
                target='_blank'
                type='link'
                size='small'
                className='pl0'
                rel='noopener noreferrer'
              >
                Privacy Policy
              </Button>
            </Col>
            <Col></Col>

            <Col xs={24} style={{ textAlign: 'right' }}>
              <Button
                key='submit'
                type='primary'
                disabled={!checkedTerm}
                loading={loadingModal}
                onClick={() => {
                  if (checkboxTerm) {
                    let checked = checkboxTerm.rcCheckbox.input.checked;

                    if (checked) {
                      setLoadingModal(true);
                      props.commonActionFromDAL(ConsoleUsersDAL, 'acceptedTermOfOrg', 'platform').then(async () => {
                        setVisibleTermPangoAccept(false);
                        setLoadingModal(false);

                        const res = await handleSetOrgId('platform');

                        if (res?.accepted) {
                          let targetUrl = '/my-account-info';

                          const qString = props.location.search;
                          const parseQuery = queryString.parse(qString);
                          if (parseQuery.target) {
                            if (parseQuery.target == 'my-account-info') {
                            } else if (parseQuery.target == 'ga') {
                              targetUrl += '/ga';
                            }
                          }

                          if (listOrgOfUser.length === 1) {
                            handleContinuteToPangoCDP(listOrgOfUser[0]?.id, targetUrl, () => {
                              props.setGlobalLoading(false);
                            });
                          }
                        }
                      });
                    } else {
                    }
                  }
                }}
              >
                Continue
              </Button>
            </Col>
          </Row>
        }
      >
        <Row type='flex' gutter={[10, 10]}>
          <Col className='pt10'>
            <div
              style={{ height: '50vh', overflowY: 'scroll' }}
              dangerouslySetInnerHTML={{
                __html:
                  response?.success && response?.result && response?.result?.term
                    ? sanitizeHtml(response?.result?.term)
                    : `<div><h1>Legal Notice</h1><div>This information asset and information system is the property of Pango.</div><div>The use of this system is governed by IT Policies under Pango.</div><div>It must be used responsibly and for authorized purposes only.</div><p>Unauthorized or improper use of this system may result in disciplinary action and/or civil charges/criminal penalties and/or prosecution of law. By continuing to use this system you indicated your awareness and consent to these terms and conditions of use.</div></div>`,
              }}
            ></div>
          </Col>
        </Row>
      </Modal>
    );
  };

  const handleSelectOrg = (item: TypeOrganization, target: string, callback: any) => {
    if (termPango?.success && !termPango?.accepted && response?.result?.active) {
      setVisibleTermPangoAccept(true);
      callback && callback();
      return;
    }

    props
      .commonActionFromDAL(ConsoleUsersDAL, 'checkUserAcceptedTermOfOrg', item.id)
      .then((resultCheckAccepted: any) => {
        //check or co term hay ko?
        let termOfOrg = handleGetTerm(item.id);

        setTerm(termOfOrg);
        setSelectedOrgName(item.name);
        setSelectedOrgCurrentAccpt(
          resultCheckAccepted && resultCheckAccepted.success ? resultCheckAccepted.accepted : false
        );

        //neu org co term va status == active va check appcepted = false thi show popup
        if (
          termOfOrg &&
          termOfOrg.active &&
          termOfOrg.term &&
          resultCheckAccepted &&
          resultCheckAccepted.success &&
          !resultCheckAccepted.accepted
        ) {
          setVisibleTermAccept(true);
          setCheckTerm(false);

          if (callback) callback();
        } else {
          handleContinuteToPangoCDP(item.id, target, callback);
        }
      });
  };

  const handleCountTotalInviteByStatus = async () => {
    try {
      const { results, success } = await props.commonActionFromDALV2(UserDAL.countTotalInviteByStatus);
      if (success) {
        setTotalInviteUser(results);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShowOrHideAlert = () =>
    showMessage ? (
      <p style={{ color: '#DF052B', display: 'flex', alignItems: 'top', gap: 5 }}>
        <span style={{ marginTop: 1 }}>
          <IconSecurity />
        </span>
        <span>{errorMsg}</span>
      </p>
    ) : null;

  const renderTheme = () => {
    let targetUrl = '/my-account-info';

    const qString = props.location.search;
    const parseQuery = queryString.parse(qString);
    if (parseQuery.target) {
      if (parseQuery.target == 'my-account-info') {
      } else if (parseQuery.target == 'ga') {
        targetUrl += '/ga';
      }
    }

    const companies = sortBy(props.currentUserOrgs.orgs.results, (item: TypeOrganization) => item.name);

    /*@ts-ignore */
    const orgUIs = props.currentUserOrgs.orgs.orgUIs;

    const companiesSearch = filter(companies, (item: TypeOrganization) => {
      return (item.name + ' ' + item.website + ' ' + item.id).toLowerCase().indexOf(query.toLowerCase()) >= 0;
    });

    const isEnabledScrolled = companiesSearch?.length > 10;

    const { avatar, totpEnabled, name } = props.user;

    const handleGetTwoCharacter = (name: string) => {
      const splitFullName = name.split(' ');
      if (splitFullName && splitFullName.length >= 2) {
        const result = splitFullName
          .slice(0, 2)
          .map((word) => word.substring(0, 1))
          .join('');
        return result;
      }
      return name.slice(0, 2).toUpperCase();
    };

    const styleIcon: React.CSSProperties = {
      position: 'absolute',
      bottom: 0,
      right: 0,
      color: '#8E00E8',
    };

    return (
      <LandingPage {...props} isSelectCompanyPage={true}>
        <>
          <div>
            <Helmet>
              <title>Select Company</title>
              <meta name='description' content='' />
            </Helmet>

            <Form className='landing-form1'>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'top', marginBottom: 30 }}>
                <span>
                  <p className='txt-black-color-90' style={{ fontSize: 26, opacity: '90%', marginBottom: 14 }}>
                    Hello {handleGetNameBeforAt(props.user.id)}
                  </p>
                  <p style={{ fontSize: 16, lineHeight: '22px', color: '#87888C', opacity: '80%' }}>
                    {!isLoading && isFirstLogin ? (
                      <span style={{ color: '#8E00E8', marginBottom: 0 }}>
                        <Icon type='loading' /> Automatically redirected to organization...
                      </span>
                    ) : (
                      <span>
                        Choose your organization to continue
                        {totalInviteUser > 0 && (
                          <>
                            <Divider type='vertical' />
                            <PopoverInviteUser
                              commonActionFromDALV2={props.commonActionFromDALV2}
                              onSuccess={() => {
                                props.setGlobalLoading(true);
                                setTimeout(() => {
                                  handleCountTotalInviteByStatus();
                                  getCurrentUserOrgs();
                                  props.setGlobalLoading(false);
                                }, 500);
                              }}
                              totalInviteUser={totalInviteUser}
                            />
                          </>
                        )}
                      </span>
                    )}
                  </p>
                </span>
                <span
                  style={{
                    padding: 4,
                    background: 'white',
                    borderRadius: 100,
                    height: 'fit-content',
                    position: 'relative',
                  }}
                >
                  <Avatar src={avatar} size={66} shape={'circle'}>
                    {handleGetTwoCharacter(name ? name : '')}
                  </Avatar>
                  {totpEnabled ? <IconCheckMark style={styleIcon} /> : <IconWarningMark style={styleIcon} />}
                </span>
              </div>

              {handleShowOrHideAlert()}

              <GoogleReCaptcha action='register' onVerify={(token: any) => setToken(token)} />

              {companies.length >= 5 ? (
                <Row type='flex' align='bottom' justify='space-between' gutter={[5, 5]} style={{ marginBottom: 15 }}>
                  <Col xs={24}>
                    <SearchCompany
                      onSearch={(e: string) => {
                        setQuery(e);
                      }}
                    />
                  </Col>
                </Row>
              ) : null}

              {companies.length >= 5 ? (
                <div
                  style={{
                    maxHeight: 445,
                    overflowY: isEnabledScrolled ? 'auto' : undefined,
                    paddingRight: isEnabledScrolled ? 8 : 0,
                  }}
                >
                  <Row type='flex' gutter={[15, 15]}>
                    {companies?.length ? (
                      companiesSearch.map((company: TypeOrganization, index) => {
                        const themeColor =
                          orgUIs && orgUIs[company.id] && orgUIs[company.id].themeColor !== null
                            ? orgUIs[company.id].themeColor
                            : '#ccc';
                        return (
                          <Col xs={12}>
                            <Card
                              style={{
                                borderRadius: 10,
                                boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.02)',
                                border: 'none',
                              }}
                              size='small'
                              hoverable
                              onClick={() => {
                                props.setGlobalLoading(true);
                                setSelectedOrgName(company.name);
                                handleSelectOrg(company, targetUrl, () => {
                                  props.setGlobalLoading(false);
                                });
                              }}
                            >
                              <div
                                className='text-card-org'
                                style={
                                  {
                                    '--hover-color': themeColor,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 15,
                                    overflow: 'hidden',
                                  } as React.CSSProperties
                                }
                              >
                                <div>
                                  <Avatar
                                    //@ts-ignore
                                    src={company.imageLink}
                                    size={50}
                                    shape='square'
                                    style={{ backgroundColor: themeColor, borderRadius: 14 }}
                                  >
                                    <span className='no-hover-color'>{handleGetTwoCharacter(company.name)}</span>
                                  </Avatar>
                                </div>

                                <div style={{ overflow: 'hidden' }}>
                                  <Typography.Text
                                    style={{ fontSize: 17, color: '#000', marginBottom: 0, display: 'block' }}
                                    ellipsis={true}
                                  >
                                    <Tooltip title={company.name} placement='topLeft'>
                                      {company.name}
                                    </Tooltip>
                                  </Typography.Text>
                                  <Typography.Text type='secondary' ellipsis={true} style={{ display: 'block' }}>
                                    <Tooltip
                                      placement='topLeft'
                                      title={company.website || 'No website has been set up for this organization.'}
                                    >
                                      {company.website || 'No website has been set up for this organization.'}
                                    </Tooltip>
                                  </Typography.Text>
                                </div>
                              </div>
                            </Card>
                          </Col>
                        );
                      })
                    ) : (
                      <Col xs={24} style={{ marginTop: 20, opacity: '90%' }}>
                        <Empty />
                      </Col>
                    )}
                  </Row>
                </div>
              ) : (
                <ListCompanySelectComponent
                  actionSelect={handleSelectOrg}
                  dataSources={companiesSearch}
                  targetUrl={targetUrl}
                  orgs={props.currentUserOrgs.orgs}
                  isFirstLogin={isFirstLogin}
                />
              )}

              <br />
              {/* <Form.Item>
                                <Typography.Text><Link to="/login">

                                </Link></Typography.Text>
                            </Form.Item> */}
              <Form.Item>
                <Button style={{ padding: 0, opacity: '90%', color: '#8E00E8' }} type='link' size='small' href='/login'>
                  {/* <FormattedMessage id="app.login.different" /> */}
                  Sign in with another account
                </Button>
              </Form.Item>
            </Form>

            {renderModalTerm()}
            {renderModalTermPango()}

            {/* <div className="landing-form-footer" >
                            <FooterLang
                                mainProps={this.props}
                                onSuccess={this.successChangeLang}
                            />
                        </div> */}
          </div>

          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Typography.Text>
              © 2016 - {moment().format('YYYY')}{' '}
              <Button
                style={{ padding: 0, opacity: '90%', color: '#8E00E8' }}
                type='link'
                size='small'
                href='https://bytetech.io/'
                target='_blank'
              >
                ByteTech
              </Button>{' '}
              All rights reserved.{' '}
              <Button
                style={{ padding: 0, opacity: '90%', color: '#8E00E8' }}
                type='link'
                size='small'
                href='https://pangocdp.com/en/privacy-policy/'
                target='_blank'
              >
                Privacy Policy
              </Button>
            </Typography.Text>
          </div>
        </>
      </LandingPage>
    );
  };

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={BIGDATA_CONSTANT.reCapchaSiteKey}
      language={props.locale}
      ref={(e: any) => {
        capchaRef.current = e;
      }}
    >
      {renderTheme()}
    </GoogleReCaptchaProvider>
  );
};

export default SelectCompanyV2Component;
